import { ListItem, ListItemText } from "@material-ui/core";
import {
  StyleRulesCallback,
  WithStyles,
  withStyles
} from "@material-ui/core/styles";
import * as React from "react";
import { IGooglePlace } from "shared/model/ICoworkGeoLocation";

interface IProps {
  place: IGooglePlace;
  onPlaceSelected: (place: IGooglePlace) => void;
  selected: boolean;
}

const styles: StyleRulesCallback = () => ({
  item: {
    padding: "16px 12px!important",
    "&:hover": {
      background: "#F5FAFC!important"
    }
  },
  listItemTextPrimary: {
    fontSize: ".95em",
    fontWeight: 400
  },
  listItemTextSecondary: {
    fontSize: ".9em",
    fontWeight: 300
  }
});

@(withStyles(styles) as any)
export default class PlacesAutoCompleteListItem extends React.Component<
  IProps & Partial<WithStyles<any>>
> {
  public render() {
    const {
      place: { name, formattedAddress },
      classes
    } = this.props;
    return (
      <ListItem
        onClick={this.onClick}
        button={true}
        className={classes!.item}
      >
        <ListItemText classes={{primary:classes!.listItemTextPrimary, secondary: classes!.listItemTextSecondary}} primary={name} secondary={formattedAddress} />
      </ListItem>
    );
  }

  private onClick = () => this.props.onPlaceSelected(this.props.place);
}



// WEBPACK FOOTER //
// ./src/scenes/Bots/Common/PlacesAutoComplete/PlacesAutoCompleteListItem.tsx